import React, { useContext, useEffect, useState } from "react";
import Close from "../../../../../images/Close.svg";
import { Title } from "../../../../../stories/Title/Title";
import { Button } from "../../../../../stories/Button/Button";
import { materialRequestListHeaders } from "./List";
import {
  FromStatus,
  MaterialRequestStatus,
  Operation,
  PageFor,
} from "../../../../../utils/Enum.types";
import { useNavigate } from "react-router-dom";
import ApprovedStatus from "../../../../../images/ApprovedStatus.svg";
import RightArrow from "../../../../../images/ArrowRight.svg";
import Input from "../../../../../stories/Input/Input";
import {
  labelClasses,
  LabeledAutocomplete,
} from "../../../../../styles/AutocompleteStyles";
import { Keys } from "../../../../../utils/Enum.keys";
import {
  CustomModal,
  getModifiedScrollHeight,
  handleMUISelectEvent,
  toInputStandardDate,
  toIsoDate,
  toStandardDate,
} from "../../../../../utils/UtilFunctions";
import { TextField } from "@mui/material";
import Compare from "../../../../../images/Compare.svg";
import ViewStatus from "../../../../../images/ViewStatus.svg";
import Pending from "../../../../../images/PendingRequest.svg";
import ViewProgress from "../../../../../images/Progress.svg";
import RejectedStatus from "../../../../../images/RejectedStatus.svg";
import { ViewModalStyles } from "../../../../../styles/CustomModalStyles";
import ViewPendingStatus from "./pending/ViewPendingStatus";
import { useLazyQuery } from "@apollo/client";
import { GetMrfs } from "./queries/queries";
import {
  AtsMrfMstEdge,
  AtsMrfMstOrderField,
  GetMrfsResult,
  GetMrfsVars,
  MrfQueryType,
} from "./queries/types";
import {
  debouncedDelay,
  emptyMessage,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
} from "../../../../../utils/constants";

import useUrlParams from "../../../../../customHooks/useUrlParams";
import { AppContext } from "../../../../../context/context";
import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import { payloadTypes } from "../../../../../context/reducer";
import useServerDateandTime from "../../../../../customHooks/useServerDateandTime";
import LoadingModal from "../../../../pages/LoadingModal";
import { useDebounce } from "../../../../../customHooks/useDebounce";

export interface formDates {
  startDate: string;
  endDate: string;
}
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  pageType: MrfQueryType;
  showFilter: boolean;
  isMrfselect: boolean;
  onSelect?: (mrfEdge: AtsMrfMstEdge) => void;
}
const ApprovedList = ({
  setModalFlag,
  pageType,
  showFilter,
  isMrfselect,
  onSelect,
}: Props) => {
  const navigate = useNavigate();
  const [approvedModal, setApprovedModal] = useState(false);
  const [rejectedModal, setRejectedModal] = useState(false);
  const [inProgressModal, setInProgressModal] = useState(false);
  const [pendingModal, setPendingModal] = useState(false);
  const [filterStatus, setFilterStatus] = useState(pageType);
  const [message, setMessage] = useState(emptyMessage);
  const { customer_id } = useUrlParams();
  const { state } = useContext(AppContext);
  
  const [searchData, setSearchData] = useState("");
  const debouncedSearch = useDebounce(searchData, debouncedDelay);
  const [materials, setMaterials] = useState<AtsMrfMstEdge[]>([]);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);

  const { data: todaysDateData, serverDate } = useServerDateandTime();

  const [dates, setDates] = useState<formDates>({
    startDate: "",
    endDate: "",
  });

  const [GetMrf, { data, loading, fetchMore }] = useLazyQuery<
    GetMrfsResult,
    GetMrfsVars
  >(GetMrfs);

  const { dispatch } = useContext(AppContext);

  useEffect(() => {
    if (customer_id && state.ActiveFinYr) {
      GetMrf({
        variables: {
          after: null,
          customerId: customer_id,
          finYrId: state.ActiveFinYr.id,
          first: ROWS_PER_PAGE,
          queryType: filterStatus,
          start_date: toIsoDate(dates.startDate),
          end_date: toIsoDate(dates.endDate),
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsMrfMstOrderField.MRF_NO,
          },
          name: debouncedSearch,
       
        },
      });
    }
  }, [GetMrf, dates, customer_id, state.ActiveFinYr, filterStatus]);

  const handleScroll = (e: React.UIEvent<HTMLUListElement, UIEvent>) => {
    const target = e.target as HTMLDivElement;
    const scrollTop = target.scrollTop;
    const scrollHeight = target.scrollHeight;
    const clientHeight = target.clientHeight;
    if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
      if (hasNextPage && !loading) {
        fetchMore({
          variables: {
            first: FETCH_MORE_DATA,
            after: endCursor,
          },
          updateQuery: (prevResult, { fetchMoreResult }) => {
            if (!fetchMoreResult) return prevResult;

            const newEdges = fetchMoreResult.GetMrfs.edges;
            const pageInfo = fetchMoreResult.GetMrfs.pageInfo;
            setEndCursor(pageInfo.endCursor);
            setHasNextPage(pageInfo.hasNextPage);

            const duplicateCheck = prevResult.GetMrfs.edges.filter(
              ({ node: { id } }) =>
                newEdges.findIndex(
                  ({ node: { id: newId } }) => newId === id
                ) !== -1
            );

            if (duplicateCheck.length > 0) return prevResult;

            return {
              GetMrfs: {
                edges: [...materials, ...newEdges],
                pageInfo,
                totalCount: data ? data.GetMrfs.totalCount! : 0,
              },
            };
          },
        });
      }
    }
  };

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetMrfs.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = materials.find(
            (employee) => employee.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setMaterials(updatedNewData);
      } else {
        setMaterials(newData);
      }
      setEndCursor(data.GetMrfs.pageInfo.endCursor);
    }
    // eslint-disable-next-line
  }, [data, loading]);

  const mrfTypeOptions = Object.values(MrfQueryType);

  useEffect(() => {
    if (todaysDateData && serverDate) {
      const getMonth = new Date(serverDate).getMonth();
      const getYear = new Date(serverDate).getFullYear();

      const firstDay = new Date(getYear, getMonth, 1); // First day of the month
      const lastDay = new Date(getYear, getMonth + 1, 0);

      setDates({
        endDate: lastDay.toString(),
        startDate: firstDay.toString(),
      });
    }
  }, [todaysDateData, serverDate]);

  return (
    <>
      <div className="approved">
        <div className="approved__title">
          <Title>
            {`View ${
              filterStatus !== MrfQueryType.ALL_MRFS
                ? filterStatus.replaceAll("_", " ")
                : "All"
            } Requests`}
          </Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
        <div className="material__select row g-0">
          <div className="col-2">
            <Input id="data_search" placeholder="Search..." />
          </div>
          {showFilter ? (
            <div className="col-2">
              <LabeledAutocomplete
                className={labelClasses.inputRoot}
                options={mrfTypeOptions}
                onKeyDown={(e) => {
                  if (e.key === Keys.ENTER) {
                    e.preventDefault();
                    handleMUISelectEvent(e);
                  }
                }}
                onChange={(event, newValue) =>
                  setFilterStatus(newValue as MrfQueryType)
                }
                openOnFocus
                forcePopupIcon
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    className={labelClasses.formControlRoot}
                    label="Status"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                )}
              />
            </div>
          ) : null}
          <div className="col-3 material__select--flex">
            <TextField
              label="Start Date"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              type="date"
              className="  --date"
              value={toInputStandardDate(dates.startDate)}
              onChange={(e) => {
                setDates({
                  ...dates,
                  startDate: e.target.value,
                });
              }}
            />
            <img src={Compare} alt="" />
            <TextField
              label="End Date"
              type="date"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              className=" material__select--date"
              value={toInputStandardDate(dates.endDate)}
              onChange={(e) => {
                setDates({
                  ...dates,
                  endDate: e.target.value,
                });
              }}
            />
          </div>
        </div>
        <div className="approved__datablock">
          <div
            className="material__list--header"
            id={`${
              filterStatus === MrfQueryType.PENDING_MRFS
                ? "bg-grey"
                : filterStatus === MrfQueryType.IN_PROGRESS_MRFS
                ? "bg-amber"
                : filterStatus === MrfQueryType.REJECTED_MRFS
                ? "bg-red"
                : filterStatus === MrfQueryType.APPROVED_MRFS
                ? "bg-green"
                : "bg-var"
            }`}
          >
            <span>
              {`Total ${
                filterStatus !== MrfQueryType.ALL_MRFS
                  ? filterStatus.replaceAll("_", " ")
                  : "All"
              } Requests`}
              :
            </span>
            <b>0</b>
          </div>
          <ul className="material__list--ul" onScroll={handleScroll}>
            {materials.map((res, index) => {
              return (
                <li
                  key={index}
                  className="material__list--li"
                  onClick={() => {
                    if (isMrfselect) {
                      dispatch({
                        type: payloadTypes.SET_MRF_ID,
                        payload: {
                          mrfId: res.node.id,
                        },
                      });
                      if (onSelect) {
                        onSelect(res);
                      }
                      setModalFlag(false);
                    }
                  }}
                >
                  <div className="material__list--li--details">
                    <div className="material__list--li--flex">
                      {index + 1}.&nbsp;
                      <b>{res.node.mrfNo}</b>
                      <>
                        <span
                          className={`material__list--li--flex${
                            res.node.acceptStatus === FromStatus.APPROVED
                              ? "--approved"
                              : res.node.acceptStatus === FromStatus.IN_PROGRESS
                              ? "--progress"
                              : res.node.acceptStatus === FromStatus.REJECTED
                              ? "--rejected"
                              : "--pending"
                          }`}
                        >
                          {res.node.acceptStatus}
                        </span>
                      </>
                    </div>
                    <div className="material__list--li--grid">
                      <div>
                        <span>{materialRequestListHeaders.Date}</span>
                        <b>{toStandardDate(res.node.mrfDate)}</b>
                      </div>
                      <div>
                        <span>
                          {materialRequestListHeaders.Subsidary_Company}
                        </span>
                        <b>{res.node.subsidiary.name}</b>
                      </div>
                      <div>
                        <span>{materialRequestListHeaders.Requested_By}</span>
                        <b>{`${res.node.raisedByUserDetails.name}`}</b>
                      </div>
                      <div>
                        <span>{materialRequestListHeaders.Item_Requested}</span>
                        <b>{res.node.itemQty}</b>
                      </div>
                      <div>
                        <span>
                          {materialRequestListHeaders.Quantity_Requested}
                        </span>
                        <b>{res.node.totalQty}</b>
                      </div>
                    </div>
                  </div>
                  {!isMrfselect ? (
                    <div className="material__list--li--actions">
                      <div
                        className="material__list--li--actions--pending"
                        onClick={() => {
                          filterStatus === MrfQueryType.APPROVED_MRFS
                            ? setApprovedModal(!approvedModal)
                            : filterStatus === MrfQueryType.REJECTED_MRFS
                            ? setRejectedModal(!rejectedModal)
                            : filterStatus === MrfQueryType.IN_PROGRESS_MRFS
                            ? setInProgressModal(!inProgressModal)
                            : setPendingModal(!pendingModal);
                        }}
                      >
                        <img
                          src={
                            {
                              [FromStatus.PENDING]: Pending,
                              [FromStatus.IN_PROGRESS]: ViewProgress,
                              [FromStatus.REJECTED]: RejectedStatus,
                              [FromStatus.APPROVED]: ApprovedStatus,
                            }[res.node.acceptStatus] || ViewStatus
                          }
                          alt=""
                        />

                        <span>View</span>
                      </div>

                      <img
                        src={RightArrow}
                        alt=""
                        onClick={() => {
                          setApprovedModal(!approvedModal);
                        }}
                      />
                    </div>
                  ) : null}
                </li>
              );
            })}
          </ul>
        </div>

        <Button mode="cancel" onClick={() => setModalFlag(false)} />
      </div>

      <CustomModal
        isOpen={approvedModal}
        onRequestClose={() => setApprovedModal(!approvedModal)}
        contentComponent={
          <ViewPendingStatus
            type={MaterialRequestStatus.APPROVED}
            setModalFlag={setApprovedModal}
            pageType={PageFor.MODAL}
          />
        }
        style={ViewModalStyles}
      />

      <CustomModal
        isOpen={rejectedModal}
        onRequestClose={() => setRejectedModal(!rejectedModal)}
        contentComponent={
          <ViewPendingStatus
            type={MaterialRequestStatus.REJECTED}
            setModalFlag={setRejectedModal}
            pageType={PageFor.MODAL}
          />
        }
        style={ViewModalStyles}
      />
      <CustomModal
        isOpen={inProgressModal}
        onRequestClose={() => setInProgressModal(!inProgressModal)}
        contentComponent={
          <ViewPendingStatus
            type={MaterialRequestStatus.INPROGRESS}
            setModalFlag={setInProgressModal}
            pageType={PageFor.MODAL}
          />
        }
        style={ViewModalStyles}
      />

      <CustomModal
        isOpen={pendingModal}
        onRequestClose={() => setPendingModal(!pendingModal)}
        contentComponent={
          <ViewPendingStatus
            type={MaterialRequestStatus.PENDING}
            setModalFlag={setPendingModal}
            pageType={PageFor.MODAL}
          />
        }
        style={ViewModalStyles}
      />
      <LoadingModal flag={loading} />
    </>
  );
};

export default ApprovedList;
